<script lang="ts" setup>
  import { computed } from 'vue'

  const props = defineProps({
    name: {
      type: String,
      required: true
    },

    width: {
      type: Number,
      default: 24
    },
  })

  const glyphSource = computed(() => {
    return `/images/glyphs/${props.name}.svg`
  })
</script>

<template>
  <img class="glyph" aria-hidden="true" :src="glyphSource" :width="$props.width" />
</template>